import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { Course, Hub, Learnspace } from '@shared/models';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { CurrentContextService } from '@shared/services/currentContextService';
import { CurrentHubService } from '@shared/services/currentHub.service';

export const CurrentContextResolver: ResolveFn<{ hub: Hub | null; learnspace: Learnspace | null; course: Course | null }> = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const contextService = inject(CurrentContextService);
  const hubService = inject(CurrentHubService);
  const courseAPIService = inject(CoursesAPIService);
  let hub;
  let learnspace;
  let course;
  if (state.url.split('/').length > 0) {
    const firstURLPart = state.url.split('/')[1];
    contextService.setAppMode(firstURLPart);
  }

  if (route.params['urlTitle']) {
    try {
      const hubURLTitle = route.params['urlTitle'];
      hub = await hubService.getOrSetCurrentHub(hubURLTitle);
    } catch (err) {
      hub = null;
    }
  }
  if (route.params['lsId']) {
    try {
      const learnspaceId = route.params['lsId'];
      learnspace = contextService.currentLearnspace?.id !== learnspaceId ? await courseAPIService.getLearnspaceById(learnspaceId).toPromise() : contextService.currentLearnspace;
    } catch (err) {
      learnspace = null;
    }
  }
  if (route.params['courseId']) {
    try {
      const courseId = route.params['courseId'];
      course = contextService.currentCourse?.id !== courseId ? await courseAPIService.getCourseInfo(courseId).toPromise() : contextService.currentCourse;
    } catch (err) {
      course = null;
    }
  }

  contextService.currentLearnspace = learnspace;
  contextService.currentCourse = course;

  return { hub, learnspace, course };
};
